
import wallpaper from "./Images/wallpaper.png";

export default function Habtext() {

    return (
        <div >



            <div className="divhabitacional">



                <div className="divhab1">

                    <div className="h2lcolumn">
                        <img className="iconsection1" src={wallpaper}></img>
                        <h2 className="textboard">H2L Engenharia</h2>


                    </div>
                    <div className="first-column">




                        <h3 className="texthab"><strong className="sh2ll">Fundada em 2016</strong>, a H2L Engenharia é referência em <strong className="sh2l">soluções inovadoras e sustentáveis</strong> no mercado da construção civil. Com sede no <strong className="sh2l">Rio de Janeiro</strong> e filial em <strong className="sh2l">São Paulo</strong>, atuamos em todo o <strong className="sh2l">território nacional</strong>, proporcionando excelência técnica, eficiência operacional e cumprimento rigoroso de prazos.<strong className="sh2l"> Mais do que projetos</strong>, construímos <strong className="sh2l">parcerias sólidas</strong> com incorporadoras, promovendo <strong className="sh2l">impacto positivo nas comunidades</strong> e gerando valor para nossos parceiros. Com inovação tecnológica, práticas sustentáveis e uma <strong className="sh2l">equipe experiente</strong>, transformamos desafios em oportunidades e concretizamos ideias!</h3>








                    </div>
                </div>



            </div>
        </div>)
}